import { normalize } from '@dtvgo/typed-normalizr';
import { CarouselEntity } from '../../utils/normalizr/entities.js';
import '../../utils/normalizr/interfaces.js';
import 'lodash/set';
import 'lodash/sortBy';
import 'lodash/mapKeys';
import 'lodash/defaultsDeep';
import '@dtvgo/constants';
import '../../utils/normalizr/constants.js';
import 'query-string';
import '../../utils/normalizr/utils.js';

function carousels(backendAxiosInstance) {
  async function getCarousel({ sourceCarouselId, source, type }, filters, { max } = {}) {
    const response = await backendAxiosInstance.get("/layouts/v3/carousels", {
      includeLanguage: true,
      includeTimeZone: true,
      includeDeviceType: true,
      params: {
        sourceCarouselId,
        source,
        type,
        max,
        ...filters
      }
    });
    response.normalizedData = normalize({ ...response.data, type, filters }, CarouselEntity);
    return response;
  }
  return {
    getCarousel
  };
}

export { carousels as default };
//# sourceMappingURL=carousels.js.map
